export enum IntegrationAuthUrlGetActionTypes {
  request = 'integration/AUTH_URL_GET/REQUEST',
  success = 'integration/AUTH_URL_GET/SUCCESS',
  failure = 'integration/AUTH_URL_GET/FAILURE',
  cancel = 'integration/AUTH_URL_GET_/CANCEL',
}

export enum IntegrationAuthTokenGetActionTypes {
  request = 'integration/AUTH_TOKEN_GET/REQUEST',
  success = 'integration/AUTH_TOKEN_GET/SUCCESS',
  failure = 'integration/AUTH_TOKEN_GET/FAILURE',
  cancel = 'integration/AUTH_TOKEN_GET_/CANCEL',
}

export enum IntegrationDeactivateActionTypes {
  request = 'integration/DEACTIVATE/REQUEST',
  success = 'integration/DEACTIVATE/SUCCESS',
  failure = 'integration/DEACTIVATE/FAILURE',
  cancel = 'integration/DEACTIVATE/CANCEL',
}
